import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { clearUserDetails, setUserDetails } from "./userDetailSlice";
import { User } from "../../models/UserModel";
import { set } from "react-datepicker/dist/date_utils";

// src/features/auth/authSlice.ts

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  isPasswordResetRequired: boolean;
  hasPasswordChanged: boolean;
}

const initialState: AuthState = {
  hasPasswordChanged: false,
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  isPasswordResetRequired: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(
      state,
      action: PayloadAction<{
        token: string;
        isPasswordResetRequired: boolean;
      }>
    ) {
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      state.isPasswordResetRequired = action.payload.isPasswordResetRequired;
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.token = null;
      state.isAuthenticated = false;
      state.isPasswordResetRequired = false;
      state.error = null;
    },
    passwordChangeRequired(state, action: PayloadAction<boolean>) {
      state.isPasswordResetRequired = action.payload;
      state.hasPasswordChanged = false;
    },
    passwordChanged(state) {
      state.hasPasswordChanged = true;
      state.isPasswordResetRequired = false;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  passwordChangeRequired,
  passwordChanged,
} = authSlice.actions;
export default authSlice.reducer;
